import { render, staticRenderFns } from "./DefaultTableVersions.vue?vue&type=template&id=4ad71368"
import script from "./DefaultTableVersions.vue?vue&type=script&lang=ts"
export * from "./DefaultTableVersions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports